/**
 * Zod schema for the `sponsors` collection.
 */

import { z } from 'zod';

export const sponsorTierSchema = z.enum([
  'platinum',
  'gold',
  'silver',
  'bronze',
  'custom',
]);

export const sponsorDocumentSchema = z.object({
  eventId: z.string(),
  name: z.string(),
  tier: sponsorTierSchema,
  description: z.string().nullable(),
  logoURL: z.string().nullable(),
  websiteURL: z.string().nullable(),
  contactEmail: z.string().nullable(),
  contactPhone: z.string().nullable(),
  /** High-visibility placement on event home screen for top-tier sponsors. */
  showOnEventHome: z.boolean(),
  sortOrder: z.number(),
});
